// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetInvoicesApiParameter } from "@insite/client-framework/Services/InvoiceService";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { TaxExemptionCertificateCollectionModel, TaxExemptionCertificateModel } from "@store/Framework/Types/ApiModels";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { GetTaxExemptionCertificatesApiParameter } from "@store/Framework/Services/TaxExemptionCertificatesService";
import TaxExemptionCertificatesState from "@store/Framework/Store/Greif/Data/TaxExemptionCertificates/TaxExemptionCertificatesState";
import { Draft } from "immer";

const initialState: TaxExemptionCertificatesState = {
    isLoading: {},
    idByCertificate: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const actions = {
    "Greif/Data/TaxExemptionCertificates/BeginLoadTaxExemptionCertificates": (
        draft: Draft<TaxExemptionCertificatesState>,
        action: { parameter: GetTaxExemptionCertificatesApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },

    "Greif/Data/TaxExemptionCertificates/CompleteLoadTaxExemptionCertificates": (
        draft: Draft<TaxExemptionCertificatesState>,
        action: {
            parameter: GetInvoicesApiParameter & UpdateSearchFieldsType;
            collection: TaxExemptionCertificateCollectionModel;
        },
    ) => {
        setDataViewLoaded(
            draft,
            action.parameter,
            action.collection,
            collection => collection.taxExemptionCertificates!,
        );

        if (draft.failedToLoadTaxExemptionCertificates) {
            draft.failedToLoadTaxExemptionCertificates = false;
        }
    },

    "Greif/Data/TaxExemptionCertificates/FailedToLoadTaxExemptionCertificates": (
        draft: Draft<TaxExemptionCertificatesState>,
    ) => {
        draft.failedToLoadTaxExemptionCertificates = true;
    },

    "Greif/Data/TaxExemptionCertificates/BeginLoadTaxExemptionCertificatesByCertificateId": (
        draft: Draft<TaxExemptionCertificatesState>,
        action: { certificateId: string },
    ) => {
        draft.isLoading[action.certificateId] = true;
    },

    "Greif/Data/TaxExemptionCertificates/CompleteLoadTaxExemptionCertificatesByCertificateId": (
        draft: Draft<TaxExemptionCertificatesState>,
        action: { model: TaxExemptionCertificateModel },
    ) => {
        delete draft.isLoading[action.model.id];
        draft.byId[action.model.id] = action.model;
        storeIdByCertificate(draft, action.model);
        if (draft.errorStatusCodeById) {
            delete draft.errorStatusCodeById[action.model.id];
        }
    },

    "Greif/Data/TaxExemptionCertificates/FailedToLoadTaxExemptionCertificatesByCertificateId": (
        draft: Draft<TaxExemptionCertificatesState>,
        action: { certificateId: string; status: number },
    ) => {
        delete draft.isLoading[action.certificateId];
        if (draft.errorStatusCodeById) {
            draft.errorStatusCodeById[action.certificateId] = action.status;
        }
    },
};

function storeIdByCertificate(draft: Draft<TaxExemptionCertificatesState>, certificate: TaxExemptionCertificateModel) {
    draft.idByCertificate[certificate.id] = certificate.id;
}

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifDataTaxExemptionCertificatesActions = Parameters<typeof reducer>[1];
export default reducer;
